import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function MediumIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 39 32" {...props}>
      <path d="M4.60323 7.06286C4.65081 6.5928 4.47155 6.12819 4.12056 5.81183L0.545176 1.50471V0.861328H11.6467L20.2276 19.6804L27.7717 0.861328H38.3548V1.50471L35.2979 4.4357C35.0343 4.63658 34.9036 4.96676 34.9582 5.29354V26.8291C34.9036 27.1559 35.0343 27.4861 35.2979 27.687L38.2833 30.6179V31.2613H23.2667V30.6179L26.3594 27.6155C26.6633 27.3116 26.6633 27.2223 26.6633 26.7576V9.35045L18.0645 31.1898H16.9025L6.89147 9.35045V23.9875C6.808 24.6029 7.01238 25.2224 7.44566 25.6674L11.468 30.5465V31.1898H0.0625V30.5465L4.0848 25.6674C4.51492 25.2217 4.70738 24.598 4.60323 23.9875V7.06286Z" />
    </SvgIcon>
  );
}
